import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DisplayHtmlContentCommonModel } from 'src/app/models/common.model';

@Component({
  selector: 'app-display-html-content-common',
  standalone: true,
  imports: [],
  templateUrl: './display-html-content-common.component.html',
})
export class DisplayHtmlContentCommonComponent {
  model: DisplayHtmlContentCommonModel;

  constructor(
    public dialogRef: MatDialogRef<DisplayHtmlContentCommonModel>,
    @Inject(MAT_DIALOG_DATA) public data: DisplayHtmlContentCommonModel) {
    this.model = data;
  }
}
